import { VeBox, VeTypography, useMediaQuery } from "@packages/ui/mui";
import { VE_ICON_GREY } from "@public/index";
import Image from "next/image";
import React from "react";

import "./authLinkDesc.scss";
import { useData } from "@providers/context";

function AuthLinkDesc() {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { configData } = useData();

  return (
    <div>
      {" "}
      <VeBox className="versionText" width={!isMobile ? "400px" : "360px"}>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href={
            configData?.configurations?.find(
              (item: any) => item?.key === "LANDING_PAGE"
            )?.value
          }
        >
          <Image src={VE_ICON_GREY} alt="VE_ICON" />
        </a>
        <VeTypography variant="label4Disabled" sx={{ textAlign: "center" }}>
          Vericap Pte. Ltd. |{" "}
          <a
            className="ftrLink"
            target="_blank"
            rel="noreferrer noopener"
            href={
              configData?.configurations?.find(
                (item: any) => item?.key === "PRIVACY_POLICY"
              )?.value
            }
          >
            Privacy Policy
          </a>{" "}
          |{" "}
          <a
            className="ftrLink"
            target="_blank"
            rel="noreferrer noopener"
            href={
              configData?.configurations?.find(
                (item: any) => item?.key === "TERMS_&_CONDITIONS"
              )?.value
            }
          >
            Terms & Conditions
          </a>
          <br />
          &copy; Vericap. All Rights Reserved.{" "}
        </VeTypography>
        <VeTypography variant="label4Disabled">v2.0.0</VeTypography>
      </VeBox>
    </div>
  );
}

export default AuthLinkDesc;
